import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'

export const SearchForm = styled.form`
  display: flex;
  flex-wrap: wrap;
`

export const SearchFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px 57px;
  color: ${colors.mainText};
  margin-bottom: 0;
  border: 1px solid ${colors.greyBlue};
  justify-content: space-between;
  @media (min-width: 576px) {
    height: 274px;
    padding: 24px 24px 50px 24px;
    border: none;
    border-radius: 8px;
  }
`
export const SearchInput = styled.input`
  height: 47px !important;
  font-size: ${variables.fontSize14};
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
  outline: none;
  padding: 16px;
  width: 100%;
  margin-bottom: 40px;
  position: relative;
  background-color: ${colors.white};
  line-height: 21px;
  color: ${colors.greyTextWhiteBg};

  &:focus {
    background-color: ${colors.white};
    outline: none;
    color: ${colors.mainText};
  }
  &:active {
    background-color: ${colors.white};
    outline: none;
    color: ${colors.mainText};
  }

  @media ${device.mobileMin} {
    border: none;
    padding: 0;
    margin: 0;
  }
`

export const HorizontalLine = styled.hr`
  margin: 0;
`

export const StyledText = styled.div`
  font-size: 18px;
  line-height: 27px;
`

export const MatchingInfoWrapper = styled.div`
  min-height: 40px;
  padding-top: 16px;
`

export const MatchingInfoContainer = styled.div`
  display: flex;
  font-display: row;
  color: ${colors.messegesYellow1};
  align-items: flex-start;
  margin-bottom: 16px;
`

export const MatchingInfoIcon = styled.div`
  margin-right: 8px;
  width: 16px;
  height: 14px;

  & img {
    width: 16px;
    height: 14px;
  }
`

export const MatchingInfoText = styled.div`
  text-align: left;
  line-height: 21px;
`

export const SearchFormBtnBlock = styled.div`
  margin: 0 auto;
`

export const ModalSubHeaderWrapper = styled.div`
  margin-bottom: 16px;
  @media (max-width: 576px) {
    margin-bottom: 0;
  }
`
